import swal from 'sweetalert2';
import { forceLogOut } from './authenticationActions';
import { current_tenant } from './tenantActions';
import axios from 'axios';
import { resolveS3ContentType } from '../utils/s3ContentType';

// URL base del backend.
export const ROOT_URL = current_tenant === 'ecentroevaluacion' ? process.env.REACT_APP_ROOT_URL_EVALU : process.env.REACT_APP_ROOT_URL_ESPAN

// URL base del frontend 
export const hostname = window.location.host;

// Protocolo del host
export const host_protocol = window.location.protocol;

//Se debe cambiar la direccion de redireccion cuando se abran los puertos
export const LOG_IN_URL_OUTLOOK = current_tenant === 'ecentroevaluacion' ? process.env.REACT_APP_LOG_IN_URL_OUTLOOK_EVALU : process.env.REACT_APP_LOG_IN_URL_OUTLOOK_ESPAN
export const LOG_IN_URL_GMAIL = current_tenant === 'ecentroevaluacion' ? process.env.REACT_APP_LOG_IN_URL_GMAIL_EVALU : process.env.REACT_APP_LOG_IN_URL_GMAIL_ESPAN
export const LOG_IN_URL_YAHOO = current_tenant === 'ecentroevaluacion' ? process.env.REACT_APP_LOG_IN_URL_YAHOO_EVALU : process.env.REACT_APP_LOG_IN_URL_YAHOO_ESPAN


// URL de redirección de los servicios de autenticación.
// Dependiendo del ambiente usa la URL de redirección de producción o desarrollo.
export const REDIRECT_URI = current_tenant === 'ecentroevaluacion' ? process.env.REACT_APP_REDIRECT_URI_EVALU : process.env.REACT_APP_REDIRECT_URI_ESPAN


export const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;

export const S3_PREFIX_MULTIMEDIA = current_tenant === 'ecentroevaluacion'
  ? process.env.REACT_APP_S3_PREFIX_MULTIMEDIA_EVALU
  : process.env.REACT_APP_S3_PREFIX_MULTIMEDIA_ESPAN;

export const S3_PREFIX_FILES = current_tenant === 'ecentroevaluacion'
  ? process.env.REACT_APP_S3_PREFIX_FILES_EVALU
  : process.env.REACT_APP_S3_PREFIX_FILES_ESPAN;

export const S3_PREFIX_EXAM_ATTACHMENTS = current_tenant === 'ecentroevaluacion'
  ? process.env.REACT_APP_S3_PREFIX_EXAM_ATTACHMENTS_EVALU
  : process.env.REACT_APP_S3_PREFIX_EXAM_ATTACHMENTS_ESPAN;

export const S3_PREFIX_MAIL_ATTACHMENTS = current_tenant === 'ecentroevaluacion'
  ? process.env.REACT_APP_S3_PREFIX_MAIL_ATTACHMENTS_EVALU
  : process.env.REACT_APP_S3_PREFIX_MAIL_ATTACHMENTS_ESPAN;

export const S3_PREFIX_OBSERVATION_PROCESSES = current_tenant === 'ecentroevaluacion'
  ? process.env.REACT_APP_S3_PREFIX_OBSERVATION_PROCESSES_EVALU
  : process.env.REACT_APP_S3_PREFIX_OBSERVATION_PROCESSES_ESPAN;

//export const SHOW_MULTIMEDIA_RECORDERS = process.env.NODE_ENV === 'production' ? false : true;
export const SHOW_MULTIMEDIA_RECORDERS = current_tenant === 'ecentroevaluacion' ? false : true;

// Código de petición con estado Prohibido.
export const FORBIDDEN_STATUS_CODE = 403;

// Código de petición con estado Entidad no procesable.
export const UNPROCESSABLE_ENTITY_STATUS_CODE = 422;

// Código de petición con estado No autorizado.
export const UNAUTHORIZED_STATUS_CODE = 401;

// Código de petición con estado Solicitud incorrecta
export const BAD_REQUEST_STATUS_CODE = 400;

// URL a información de la página principal.
export const MAIN_TEXT = `${ROOT_URL}/TextoPrincipal.html`;

// URL a información de la informacion de codificacion.
export const INFO_TEXT = `${ROOT_URL}/Infocodificacion.html`;

// URL a información de la retroalimentacion de codificacion.
export const RETRO_TEXT = `${ROOT_URL}/Retrocodificacion.html`;

// URL a manual de administrador
export const SUPPORT_ADMIN_DOC = `${ROOT_URL}/manuales/manual_administrador.pdf`;

// URL a manual de estructura
export const STRUCTURE_DOC = `/images/depgraph.svg`

// URL a manual
export const SUPPORT_DOC = `${ROOT_URL}/manual_administracion.pdf`;

// URL a manual de codificadores
export const SUPPORT_GRADER_DOC = `${ROOT_URL}/manuales/manual_codificadores.pdf`;

// URL a manual de estudiantes
export const SUPPORT_STUDENT_DOC = `${ROOT_URL}/manuales/manual_estudiantes.pdf`;

// URL a manual de revisores
export const SUPPORT_REVIEWER_DOC = `${ROOT_URL}/manuales/manual_revisores.pdf`;

//URL al manual del gestor de procesos de observación del módulo de videos
export const OBSERVER_ADMIN_DOC = `${ROOT_URL}/manuales/Manual_Gestor_Procesos_Observacion.pdf`;

//URL al manual de observador del módulo de videos
export const OBSERVER_DOC = `${ROOT_URL}/manuales/Manual_Observador.pdf`;

// URL a la plantilla de subida para asignaciones de codificador.
export const COURSES_ASIGRUP_TEMPL_DOC= `${ROOT_URL}/Plantilla_Codificador.xlsx`;

// URL a la plantilla de subida para estudiantes a una ventana de aplicacíon.
export const APWINDOWS_USERS_TEMPL_DOC= `${ROOT_URL}/Plantilla_subida_de_estudiantes.xlsx`;

// URL a la plantilla de subida para estudiantes a una ventana de aplicacíon.
export const APWINDOWS_TEMPL_DOC= `${ROOT_URL}/Plantilla_subida_de_ventanas.xlsx`;

// URL a la plantilla de carga masiva de usuarios con roles
export const USR_TEMPL_DOC= `${ROOT_URL}/plantilla_carga_masiva_usuario.xlsx`;

//// URL a la plantilla de subida para estudiantes a una ventana de aplicacíon.
export const APWINDOWS_USR_DOC= `${ROOT_URL}/Plantilla_estudiante-ventana.xlsx`;

// Extensión para manejo de respuestas (elementos) sin adjunto
export const NO_FILE_EXTENSION = 'no';

// Extensiones de adjuntos aceptadas para manejo de embebidos
export const ACCEPTED_FORMATS = ['pdf', 'txt', 'html', 'webm', 'png', 'jpg', 'jpeg']

// Extensiones de adjuntos multimedia aceptadas para manejo de embebidos
export const ACCEPTED_MULTIMEDIA_FORMATS = ['mp4', 'mov','mp3']

// Cantidad de elementos para paginación
export const PAGINATION = '?page%5Bnumber%5D=1&page%5Bsize%5D=10';

// Cantidad de elementos para paginación
export const SHORT_PAGINATION = '?page%5Bnumber%5D=1&page%5Bsize%5D=5';

// Cantidad de elementos para paginación de reportes
export const REPORT_PAGINATION = '?page%5Bnumber%5D=1&page%5Bsize%5D=1';

// Cantidad de elementos para paginación de reportes
export const COURSE_REPORT_COLORS = [
  'rgba(220, 220, 220, 0.5)',
  'rgba(255, 80, 80, 0.5)',
  'rgba(255, 153, 51, 0.5)',
  'rgba(255, 255, 102, 0.5)',
  'rgba(153, 255, 102, 0.5)',
  'rgba(0, 204, 102, 0.5)',
]

export const DEFAULT_DATA_TABLE_ORDER ={
  "language": {
    "search": "Buscar: ",
    "sProcessing":    "Procesando...",
    "sLengthMenu":    "Mostrar _MENU_ registros",
    "sZeroRecords":   "No se encontraron resultados",
    "sEmptyTable":    "Ningún dato disponible en esta tabla",
    "sInfo":          "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
    "sInfoEmpty":     "Mostrando registros del 0 al 0 de un total de 0 registros",
    "sInfoFiltered":  "(filtrado de un total de _MAX_ registros)",
    "sInfoPostFix":   "",
    "sInfoThousands":  ",",
    "sLoadingRecords": "Cargando...",
    "oPaginate": {
        "sFirst":    "Primero",
        "sLast":    "Último",
        "sNext":    "Siguiente",
        "sPrevious": "Anterior"
    }
  },
  stateSave: false,
  ordering: true,
  paging: false,
  destroy: true
  }

/**
 * Manejador de errores de autorización.
 *
 * @export isUnauthorizedError
 * @param {*} error : Información del error a manejar.
 * @param {*} dispatch : Función para manejo de
 * @returns Si hubo o no error asociado a autorización.
 */
 export function isUnauthorizedError(error, dispatch) {
  if (error && error.request && error.request.status === UNAUTHORIZED_STATUS_CODE) {
    swal(
      'No recordamos quién eres',
      'Por favor vuelve a iniciar sesión para poder realizar esta acción',
      'error'
    );
    forceLogOut(dispatch);
    return true;
  }
  return false;
}

/**
 * Manejo de cabeceras de autenticación. La información se obtiene del
 * LocalStorage del navegador (token de autenticación e email).
 *
 * @export getAuthHeaders
 * @returns Objeto con los headers de autenticación asociados al usuario actual.
 */
export function getAuthHeaders() {
  return {
    headers: {
      'X-User-Token': sessionStorage.getItem('authenticationToken'),
      'X-User-Email': sessionStorage.getItem('email')
    }
  };
}

/**
 * Obtiene una URL presignada de S3 para subir un archivo.
 *
 * @export getS3UploadUrl
 * @param {string} endpoint Ruta del upload_url (ej. /answers/upload_url)
 */
export async function getS3UploadUrl(endpoint, filename, bucket, prefix, contentType = 'application/octet-stream') {
  const ip = sessionStorage.getItem('ip_add') || '';
  const response = await axios.get(
    `${ROOT_URL}${endpoint}?filename=${encodeURIComponent(filename)}&bucket=${encodeURIComponent(bucket)}&prefix=${encodeURIComponent(prefix)}&content_type=${encodeURIComponent(contentType)}&sip=${ip}`,
    getAuthHeaders()
  );
  return response.data;
}

/**
 * Sube un archivo a S3 usando una URL presignada (PUT).
 *
 * @export putFileToS3
 */
export async function putFileToS3(presignedUrl, file, contentType, onUploadProgress) {
  const config = {
    headers: { 'Content-Type': contentType },
  };
  if (onUploadProgress) {
    config.onUploadProgress = onUploadProgress;
  }
  await axios.put(presignedUrl, file, config);
}

/**
 * Obtiene URL presignada y sube el archivo a S3.
 *
 * @export uploadFileViaS3
 */
export async function uploadFileViaS3(endpoint, file, filename, bucket, prefix, contentType, onUploadProgress) {
  const resolvedContentType = resolveS3ContentType(file, filename, contentType);
  const data = await getS3UploadUrl(endpoint, filename, bucket, prefix, resolvedContentType);
  await putFileToS3(data.url, file, data.content_type || resolvedContentType, onUploadProgress);
  return filename;
}

/**
 * Obtiene una URL presignada de S3 para leer un archivo.
 *
 * @export getS3FileUrl
 */
export async function getS3FileUrl(filename, bucket, prefix) {
  try {
    const ip = sessionStorage.getItem('ip_add') || '';
    const response = await axios.get(
      `${ROOT_URL}/answers/read_url?filename=${encodeURIComponent(filename)}&bucket=${encodeURIComponent(bucket)}&prefix=${encodeURIComponent(prefix)}&sip=${ip}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error obteniendo URL de lectura S3:', error);
    swal({
      type: 'error',
      title: 'Error',
      text: 'No se pudo obtener el enlace para leer el archivo. Por favor intente nuevamente.',
    });
    throw error;
  }
}

/**
 * Obtiene una URL presignada de S3 para leer archivos de videos/procesos de observación.
 *
 * @export getObservationS3FileUrl
 */
export async function getObservationS3FileUrl(filename, bucket, prefix) {
  try {
    const ip = sessionStorage.getItem('ip_add') || '';
    const response = await axios.get(
      `${ROOT_URL}/videos/read_url?filename=${encodeURIComponent(filename)}&bucket=${encodeURIComponent(bucket)}&prefix=${encodeURIComponent(prefix)}&sip=${ip}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error obteniendo URL de lectura S3:', error);
    swal({
      type: 'error',
      title: 'Error',
      text: 'No se pudo obtener el enlace para leer el archivo. Por favor intente nuevamente.',
    });
    throw error;
  }
}
